import { Link } from '@tanstack/react-router';
import { Sticker } from '@/components/ui';
import { SignupForm } from '@/features/auth/request-form';

export function SignupPage() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <Sticker flavor="citron" rotate={-3}>
          new here
        </Sticker>
        <h1 className="mt-4 text-3xl font-semibold">Make an account</h1>
        <p className="mt-2 text-sm text-ink-soft">
          Pick a password. We’ll email you a code once to confirm your address.
        </p>
      </div>
      <SignupForm />
      <p className="text-sm text-ink-soft">
        Already have an account?{' '}
        <Link to="/login" className="font-semibold underline">
          Log in
        </Link>
      </p>
    </div>
  );
}
